import Skeleton from "react-loading-skeleton";
import { DarkSkeletonTheme, ImageBone, TextBlock } from "./shared";

const GruppoSkeleton = () => (
  <DarkSkeletonTheme>
    <div aria-busy="true" aria-live="polite">
      <section className="bg-empty pt-16 lg:pt-40">
        <div className="flex-col-reverse lg:flex-row flex items-center px-10 py-20 gap-20">
          <div className="w-full flex flex-col gap-8">
            <Skeleton height={56} width={220} />
            <TextBlock lines={5} />
            <Skeleton height={22} width={140} />
          </div>
          <ImageBone className="shrink-0 h-40 w-40 lg:h-80 lg:w-96" />
        </div>
      </section>

      <div className="relative">
        <div className="border-footer" />
        <section className="bg-empty w-full">
          <div className="p-10 relative flex flex-col gap-10">
            <Skeleton className="max-w-xs w-full" height={48} />
            <Skeleton className="max-w-md w-full" height={28} />
            <TextBlock lines={14} />
            <Skeleton className="max-w-sm w-full" height={28} />
            <TextBlock lines={12} />
          </div>
        </section>
      </div>

      <section className="bg-empty pb-16 lg:pb-40 pt-16">
        <div className="hidden lg:grid grid-cols-3 gap-10 !w-2/3 mx-auto">
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={i} className="w-full" height={240} borderRadius={4} />
          ))}
        </div>
        <div className="lg:hidden px-10">
          <Skeleton className="w-full" height={240} borderRadius={4} />
        </div>
      </section>
    </div>
  </DarkSkeletonTheme>
);

export default GruppoSkeleton;
